var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionhistoryicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_39_1",
    "data-name": "Component 39 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.682,
    height: 48.297,
    viewBox: "0 0 53.682 48.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M264.866,503.867a18.766,18.766,0,1,1,19.025,18.758A18.781,18.781,0,0,1,264.866,503.867Zm21.434-5.329c0-1.74.005-3.479-.005-5.219a3.67,3.67,0,0,0-.111-.991,2.66,2.66,0,0,0-5.212.748q-.025,4.526,0,9.053a1.319,1.319,0,0,1-.439,1.037q-2.016,1.984-4,4.008a2.675,2.675,0,1,0,3.792,3.773c1.715-1.694,3.41-3.408,5.116-5.111a2.765,2.765,0,0,0,.856-2.082C286.286,502.017,286.3,500.277,286.3,498.538Z",
    transform: "translate(-264.843 -474.33)",
    fill: "#5487de"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M291.722,476.523h24.015a2.588,2.588,0,0,1,2.49,1.493,2.555,2.555,0,0,1-.243,2.786,2.821,2.821,0,0,1-2.473,1.1q-9.557-.006-19.112,0H267.858a2.782,2.782,0,0,1-2.813-1.7,2.682,2.682,0,0,1,2.6-3.675Q279.681,476.519,291.722,476.523Z",
    transform: "translate(-264.847 -476.522)",
    fill: "#5487de"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M302.745,516.042c-1.74,0-3.479,0-5.217,0a2.7,2.7,0,0,1-2.8-2.625,2.67,2.67,0,0,1,2.633-2.733c3.624-.049,7.25-.055,10.875,0a2.593,2.593,0,0,1,2.578,2.871,2.664,2.664,0,0,1-2.786,2.484Q305.385,516.046,302.745,516.042Z",
    transform: "translate(-257.164 -467.746)",
    fill: "#5487de"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M302.755,490.429c-1.74,0-3.479,0-5.219,0a2.684,2.684,0,1,1-.124-5.365q5.374-.058,10.749,0a2.625,2.625,0,0,1,2.655,2.811,2.658,2.658,0,0,1-2.781,2.556C306.275,490.432,304.515,490.429,302.755,490.429Z",
    transform: "translate(-257.164 -474.333)",
    fill: "#5487de"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M304.368,502.135c.857,0,1.715,0,2.573,0a2.659,2.659,0,0,1,2.768,2.494,2.609,2.609,0,0,1-2.582,2.864c-1.838.067-3.682.065-5.522,0a2.644,2.644,0,0,1-2.6-2.8,2.686,2.686,0,0,1,2.79-2.555C302.652,502.133,303.511,502.135,304.368,502.135Z",
    transform: "translate(-256.063 -469.935)",
    fill: "#5487de"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M304.348,493.614c.923,0,1.845-.019,2.766,0a2.658,2.658,0,0,1,.006,5.315q-2.765.038-5.532,0a2.658,2.658,0,0,1-.006-5.314C302.5,493.593,303.427,493.614,304.348,493.614Z",
    transform: "translate(-256.063 -472.128)",
    fill: "#5487de"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionhistoryicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/transaction.history.icon.16f0d5e3744003fe20f9283a3278304b.svg";
export { ForwardRef as ReactComponent };